import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild } from "@angular/core";
import { delay, sortFloat, SharedService } from '../../../shared'
import { CannabisOption, THC_CBD_Group, PartnerNamesEnum } from '../../shared';
import { QuestOneCenterRadius } from '../../data';
import { Options } from 'ngx-slider-v2';
import { RangeSliderComponent } from '../../../modules/range-slider';
import Grid from 'tui-grid';

import * as $ from 'jquery';
import * as d3 from "d3";

@Component({
    selector: 'product-popup',
    templateUrl: "./product-popup.component.html",
    styleUrls: ["./product-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ProductPopupComponent implements OnInit {
    @Input() partnerName: string = "";
    @Input() ProductTableSortingColumn: string = "";
    @Input() batchData: any[] = [];
    @Input() productValue: string;
    @Input() productOneOption: CannabisOption;
    @Input() secTwoQuestTwoOption: CannabisOption;
    @Input() secTwoQuestOneGroup: THC_CBD_Group;
    @Output() onSelectBatch = new EventEmitter<any>();

    @ViewChild("rangeSliderTHC", { static: true }) rangeSliderTHC: RangeSliderComponent;
    @ViewChild("rangeSliderCBD", { static: true }) rangeSliderCBD: RangeSliderComponent;

    PartnerNamesEnum = PartnerNamesEnum;

    productGrid: Grid;
    selectedRowKey: string = "";

    activeTab: 'TABLE' | 'DIAGRAM' = 'TABLE';

    producerName: string = "";
    productTypes: string[] = [];
    strainFamilies: string[] = [];
    strain: string = "";

    newBatchData: any[] = [];
    producerNameList: string[] = [];

    productTypeList: string[] = [];
    strainFamilyList: string[] = ["Sativa", "Indica", "Hybrid", "Indica dom. Hybrid", "Balanced Hybrid", "Sativa dom. Hybrid"];
    @Input() strainList: string[] = [];

    rangeStep: number = 1;

    @Input() minTHC: number = 0;
    @Input() maxTHC: number = 100;
    thcRange: number[] = [this.minTHC, this.maxTHC];

    @Input() minCBD: number = 0;
    @Input() maxCBD: number = 100;
    cbdRange: number[] = [this.minCBD, this.maxCBD];

    sliderValue: number = 0;
    sliderOptions: Options = {
        floor: 0,
        ceil: 20,
        showSelectionBar: true,
        step: 0.1,
        showTicks: false
    };

    productSvg: any;
    productTooltip: any;

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    get jsPanelContentHeight() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
        }
        else {
            return document.body.clientHeight;
        }
    }

    get jsPanelContentWidth() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientWidth;
        }
        else {
            return document.body.clientWidth;
        }
    }

    get productTopContent() {
        if (document.getElementById("product-top-section")) {
            return document.getElementById("product-top-section").clientHeight;
        } else {
            return 100;
        }
    }

    get diagramBodyHeight() {
        return this.jsPanelContentHeight - this.productTopContent - 50;
    }

    get gridBodyHeight() {
        return this.jsPanelContentHeight - this.productTopContent - 45 - 50;
    }

    get GroupTitle() {
        return (this.secTwoQuestOneGroup && this.secTwoQuestOneGroup.Title) ? this.secTwoQuestOneGroup.Title : "";
    }

    get isTHCCBDSelected() {
        return this.GroupTitle && this.GroupTitle.length > 0;
    }

    get IsTHC() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") > -1;
    }

    get IsOnlyTHC() {
        return this.GroupTitle && this.GroupTitle.indexOf("CBD") === -1;
    }

    get IsOnlyCBD() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") === -1;
    }

    get IsDronabinol() {
        return this.GroupTitle && this.GroupTitle.indexOf("CBD") === -1;
    }

    get IsTHCAndCBD() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") > -1 && this.GroupTitle.indexOf("CBD") > -1;
    }

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        this.thcRange = [this.minTHC, this.maxTHC];
        this.cbdRange = [this.minCBD, this.maxCBD];

        this.setProductTypeList(this.secTwoQuestOneGroup);
    }

    setNewBatchData(group) {
        let component = this;
        this.newBatchData = [];

        let maxTHC = 0;
        let maxCBD = 0;

        this.batchData.forEach(batch => {
            let newBatch = { ...batch, SimilarBatches: [] };
            if (batch.SimilarBatches.length) {
                batch.SimilarBatches.forEach(item => {
                    if (component.productTypeList.indexOf(item.ProductType) > -1) {
                        newBatch.SimilarBatches.push(item);
                    }
                })
            }
            let check = false;
            if (newBatch.SimilarBatches.length) {
                component.newBatchData.push(batch);
                check = true;
            } else {
                if (component.productTypeList.indexOf(batch.ProductType) > -1) {
                    component.newBatchData.push(batch);
                    check = true;
                }
            }
            if (check) {
                if (parseFloat(batch.THC) > maxTHC) {
                    maxTHC = parseFloat(batch.THC);
                }
                if (parseFloat(batch.CBD) > maxCBD) {
                    maxCBD = parseFloat(batch.CBD);
                }
            }
        })

        maxTHC = Math.ceil(maxTHC) + 1;
        maxCBD = Math.ceil(maxCBD) + 1;
        this.maxTHC = maxTHC;
        this.maxCBD = maxCBD;

        this.setProducersNameList();

        if (group) {
            this.fnUpdateSliderValues(group);
        }
    }

    setProducersNameList() {
        let component = this;
        this.producerNameList = [];
        this.newBatchData.forEach(batch => {
            if (batch.SimilarBatches.length) {
                batch.SimilarBatches.forEach(item => {
                    if (item.ProducerName && component.producerNameList.indexOf(item.ProducerName.trim()) === -1) {
                        component.producerNameList.push(item.ProducerName.trim());
                    }
                })
            }
            if (batch.ProducerName && component.producerNameList.indexOf(batch.ProducerName.trim()) === -1) {
                component.producerNameList.push(batch.ProducerName.trim());
            }
        })
        this.producerNameList.sort();
    }

    setProductTypeList(group) {
        this.productTypeList = [];
        switch (this.partnerName) {
            case PartnerNamesEnum.ALTHEA:
                break;
            case PartnerNamesEnum.FOUR_20_PHARMA:
                if (this.IsDronabinol) {
                    this.productTypeList.push("Blüten");
                }
                break;
            default:
                this.productTypeList.push("Blüten");
                break;
        }

        if (!this.partnerName || this.partnerName == PartnerNamesEnum.AVEXTRA) {
            if (this.IsTHCAndCBD) {
                this.productTypeList.push("Cannabisextrakt Kapseln");
            }
        }

        this.productTypeList.push("Extrakt");
        switch (this.partnerName) {
            case PartnerNamesEnum.ADREX:
            case PartnerNamesEnum.AVEXTRA:
            case PartnerNamesEnum.ALTHEA:
            case PartnerNamesEnum.BETAHEALTH:
            case PartnerNamesEnum.SWISS:
            case PartnerNamesEnum.FOUR_20_PHARMA:
                break;
            default: {
                this.productTypeList.push("Fertigarzneimittel");
            }
        }

        switch (this.partnerName) {
            case PartnerNamesEnum.AVEXTRA:
                if (this.IsDronabinol || !this.isTHCCBDSelected) {
                    this.productTypeList.push("Dronabinol");
                }
                break;
            case PartnerNamesEnum.ALTHEA:
            case PartnerNamesEnum.BETAHEALTH:
            case PartnerNamesEnum.FOUR_20_PHARMA:
                break;
            default: {
                if (this.IsDronabinol || !this.isTHCCBDSelected) {
                    this.productTypeList.push("Dronabinol");
                }
                if (!this.IsTHC || !this.isTHCCBDSelected) {
                    this.productTypeList.push("Cannabidiol");
                }
            }
        }
        this.setProductTypes();
        this.cd.detectChanges();
        this.setNewBatchData(group);
    }

    setProductTypes() {
        this.productTypes = [];
        if (this.secTwoQuestTwoOption) {
            if (this.secTwoQuestTwoOption.Label.indexOf("Cannabisblüten") > -1) {
                this.productTypes.push("Blüten");
            }
            if (this.secTwoQuestTwoOption.Label.indexOf("Cannabisextrakt") > -1) {
                this.productTypes.push("Extrakt");
            }

            switch (this.partnerName) {
                case PartnerNamesEnum.ADREX:
                case PartnerNamesEnum.AVEXTRA:
                case PartnerNamesEnum.ALTHEA:
                case PartnerNamesEnum.BETAHEALTH:
                case PartnerNamesEnum.SWISS:
                case PartnerNamesEnum.FOUR_20_PHARMA:
                    break;
                default: {
                    if (this.secTwoQuestTwoOption.Label.indexOf("Fertigarzneimittel") > -1) {
                        this.productTypes.push("Fertigarzneimittel");
                    }
                }
            }

            if (!this.partnerName || this.partnerName == PartnerNamesEnum.AVEXTRA) {
                if (this.IsTHCAndCBD) {
                    if (this.secTwoQuestTwoOption.Label.indexOf("Cannabisextrakt") > -1) {
                        this.productTypes.push("Cannabisextrakt Kapseln");
                    }
                }
            }

            switch (this.partnerName) {
                case PartnerNamesEnum.AVEXTRA:
                    if (this.IsDronabinol || !this.isTHCCBDSelected) {
                        if (this.secTwoQuestTwoOption.Label.indexOf("Dronabinol") > -1) {
                            this.productTypes.push("Dronabinol");
                        }
                    }
                    break;
                case PartnerNamesEnum.ALTHEA:
                case PartnerNamesEnum.BETAHEALTH:
                case PartnerNamesEnum.FOUR_20_PHARMA:
                    break;
                default: {
                    if (this.IsDronabinol || !this.isTHCCBDSelected) {
                        if (this.secTwoQuestTwoOption.Label.indexOf("Dronabinol") > -1) {
                            this.productTypes.push("Dronabinol");
                        }
                    }
                    if (!this.IsTHC || !this.isTHCCBDSelected) {
                        if (this.secTwoQuestTwoOption.Label.indexOf("Cannabidiol") > -1) {
                            this.productTypes.push("Cannabidiol");
                        }
                    }
                }
            }

        }
    }

    changeTab(tab) {
        if (this.activeTab != tab) {
            this.activeTab = tab;
            this.productGrid = undefined;
            this.fnUpdatePopupContent(false);
        }
    }

    selectProductType(item) {
        const index = this.productTypes.indexOf(item);
        if (index >= 0) {
            this.productTypes.splice(index, 1);
        } else {
            this.productTypes.push(item);
        }
        if (this.secTwoQuestOneGroup) {
            this.fnUpdateSliderValues(this.secTwoQuestOneGroup);
        }
        this.filterBatchGrid();
    }

    selectStrainFamily(item) {
        const index = this.strainFamilies.indexOf(item);
        if (index >= 0) {
            this.strainFamilies.splice(index, 1);
        } else {
            this.strainFamilies.push(item);
        }
        this.filterBatchGrid();
    }

    selectAllStrainFamily() {
        if (this.strainFamilies.length === this.strainFamilyList.length) {
            this.strainFamilies = [];
        } else {
            this.strainFamilies = [...this.strainFamilyList];
        }
        this.filterBatchGrid();
    }

    sliderValueChanges(event) {
        this.filterBatchGrid();
    }

    updateRangeSlider() {
        this.rangeSliderTHC.updateRangeSlider();
        this.rangeSliderCBD.updateRangeSlider();
    }

    selectGroup(group: THC_CBD_Group) {
        this.secTwoQuestOneGroup = group;
        this.setProductTypeList(group);
    }

    fnUpdateSliderValues(group: THC_CBD_Group) {
        let minTHC = this.minTHC;
        let maxTHC = this.maxTHC;
        let minCBD = this.minCBD;
        let maxCBD = this.maxCBD;

        if (group.THC && group.THC.Min && group.THC.Min >= this.minTHC) {
            minTHC = group.THC.Min;
        }
        if (group.THC && group.THC.Max && group.THC.Max <= this.maxTHC) {
            maxTHC = group.THC.Max;
        }
        if (group.CBD && group.CBD.Min && group.CBD.Min >= this.minCBD) {
            minCBD = group.CBD.Min;
        }
        if (group.CBD && group.CBD.Max && group.CBD.Max <= this.maxCBD) {
            maxCBD = group.CBD.Max;
        }
        if (this.productTypes.indexOf("Fertigarzneimittel") > -1) {
            minTHC = 0;
            minCBD = 0;
        }
        if (minTHC >= maxTHC) {
            minTHC = maxTHC - 1;
        }
        if (minCBD >= maxCBD) {
            minCBD = maxCBD - 1;
        }
        if (minTHC < 0) {
            minTHC = 0;
        }
        if (minCBD < 0) {
            minCBD = 0;
        }

        let filteredRecords = this.parseFilteredData;
        for (var i = 0; i < filteredRecords.length; i++) {
            let batch = filteredRecords[i];

            if (minTHC >= parseFloat(batch.THC)) {
                minTHC = parseFloat(batch.THC);
            }
            if (maxTHC <= parseFloat(batch.THC)) {
                maxTHC = parseFloat(batch.THC);
            }
            if (minCBD >= parseFloat(batch.CBD)) {
                minCBD = parseFloat(batch.CBD);
            }
            if (maxCBD <= parseFloat(batch.CBD)) {
                maxCBD = parseFloat(batch.CBD);
            }
            minTHC = Math.floor(minTHC);
            minCBD = Math.floor(minCBD);
            maxTHC = Math.ceil(maxTHC);
            maxCBD = Math.ceil(maxCBD);
        }

        this.thcRange = [minTHC, maxTHC];
        this.cbdRange = [minCBD, maxCBD];
        this.rangeSliderTHC.update(this.thcRange);
        this.rangeSliderCBD.update(this.cbdRange);
        this.cd.detectChanges();
    }

    async fnUpdatePopupContent(resize) {
        this.cd.detectChanges();
        if (this.activeTab === 'TABLE') {
            if (this.productGrid) {
                let filteredData = this.getFilteredData;
                if (this.selectedRowKey.length) {
                    let matched = false;
                    for (var i = 0; i < filteredData.length; i++) {
                        let childrens = filteredData[i]._children || [];
                        for (var j = 0; j < childrens.length; j++) {
                            if (childrens[j].rowKey == this.selectedRowKey) {
                                filteredData[i]._attributes.expanded = true;
                                matched = true;
                                break;
                            }
                        }
                        if (matched) {
                            break;
                        }
                    }
                }

                this.productGrid.setBodyHeight(this.gridBodyHeight);
                this.productGrid.resetData(filteredData);
                this.productGrid.refreshLayout();

                if (this.selectedRowKey.length) {
                    var allData = this.productGrid.getData();
                    for (var i = 0; i < allData.length; i++) {
                        if (allData[i].rowKey == this.selectedRowKey) {
                            var rowKey = allData[i].rowKey.toString();
                            this.productGrid.check(rowKey);
                            this.productGrid.focus(rowKey, "ProductName", true);
                            break;
                        }
                    }
                }
            } else {
                //this.addAutoCompletedToFilter();
                this.initializeBatchGrid(this.productValue, this.getAllData);
            }
            //this.thcDiagram();
            //this.cbdDiagram();
        }
        else if (this.activeTab === 'DIAGRAM') {
            this.initializeDiagram();
        }

        if (resize) {
            this.updateRangeSlider();
            await delay(0);
            this.updateRangeSlider();
        }
    }


    addAutoCompletedToFilter() {
        let component = this;
        window["autocomplete"]($(`#search-batch-data`), component.newBatchData, 'ProducerName', /.*/, false, function (value) {
            component.producerName = value;
            component.filterBatchGrid();
        });
    }

    filterBatch(batch) {
        if ((this.producerName.length ? batch.ProducerName.toString().trim().toUpperCase().indexOf(this.producerName.toUpperCase()) > -1 : true)
            && (this.productTypes.length ? this.productTypes.indexOf(batch.ProductType) > -1 : true)
            && (this.strain.length ? batch.Strain && batch.Strain.toString().trim().toUpperCase().indexOf(this.strain.trim().toUpperCase()) > -1 : true)
            && (this.strainFamilies.length ? this.strainFamilies.indexOf(batch.StrainFamily) > -1 : true)) {
            return true;
        }
        return false;
    }

    getSortedData(data) {
        data.forEach(record => {
            record["_attributes"] = { ...record._attributes, expanded: false };
            if (record._children) {
                record._children.forEach(item => {
                    item["_attributes"] = { ...item._attributes, expanded: false };
                })
            }
        })

        switch (this.ProductTableSortingColumn) {
            case "ProductName":
                data.sort(this.compareProductName);
                break;
            case "ProducerName":
                data.sort(this.compareProducerName);
                break;
            case "ProductType":
                data.sort(this.compareProductType);
                break;
            default:
                data.sort(this.compare);
                break;
        }
        return data;
    }

    get getAllData() {
        return this.getSortedData(this.batchData);
    }

    get parseFilteredData() {
        let component = this;
        let filteredRecords = [];
        if (this.producerName.length || this.productTypes.length || this.strain.length || this.strainFamilies.length) {
            this.newBatchData.forEach(batch => {
                let records = [];
                if (batch.SimilarBatches.length) {
                    batch.SimilarBatches.forEach(item => {
                        if (component.filterBatch(item)) {
                            records.push(item);
                        }
                    })
                }
                if (records.length) {
                    batch["_children"] = records;
                    filteredRecords.push(batch);
                } else {
                    if (component.filterBatch(batch)) {
                        filteredRecords.push(batch);
                    }
                }
            })
        } else {
            filteredRecords = this.newBatchData;
        }
        return filteredRecords;
    }

    get getFilteredData() {
        let filteredRecords = this.parseFilteredData;

        var filtered = [];
        const minTHC = this.thcRange[0];
        const maxTHC = this.thcRange[1];
        const minCBD = this.cbdRange[0];
        const maxCBD = this.cbdRange[1];
        for (var i = 0; i < filteredRecords.length; i++) {
            let batch = filteredRecords[i];

            if (parseFloat(batch.THC) >= minTHC &&
                parseFloat(batch.THC) <= maxTHC &&
                parseFloat(batch.CBD) >= minCBD &&
                parseFloat(batch.CBD) <= maxCBD) {
                filtered.push(batch);
            }
        }


        return this.getSortedData(filtered);
    }

    compare(a, b) {
        if (a.ProductName < b.ProductName) {
            return -1;
        }
        if (a.ProductName > b.ProductName) {
            return 1;
        }
        return 0;
    }

    compareProductName(a, b) {
        if (a.ProductName < b.ProductName) {
            return -1;
        }
        if (a.ProductName > b.ProductName) {
            return 1;
        }
        return 0;
    }

    compareProducerName(a, b) {
        if (a.ProducerName < b.ProducerName) {
            return -1;
        }
        if (a.ProducerName > b.ProducerName) {
            return 1;
        }
        return 0;
    }

    compareProductType(a, b) {
        if (a.ProductType < b.ProductType) {
            return -1;
        }
        if (a.ProductType > b.ProductType) {
            return 1;
        }
        return 0;
    }

    chooseProducerName(producerName) {
        this.producerName = producerName;
        this.filterBatchGrid();
    }

    cPNTimer: any;
    keyupProducerName(event) {
        let keyCode = event.which || event.keyCode;
        let skipKeyCodes = [16, 17, 18, 19, 20, 33, 34, 35, 36, 37, 38, 39, 40, 45, 91, 92, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 144, 145];
        if (skipKeyCodes.indexOf(keyCode) >= 0) {
            return;
        }
        clearTimeout(this.cPNTimer);
        this.cPNTimer = setTimeout(() => {
            this.filterBatchGrid();
        }, 500);
    }

    filterBatchGridTimer: any;
    filterBatchGrid() {
        clearTimeout(this.filterBatchGridTimer);
        this.filterBatchGridTimer = setTimeout(() => {
            this.fnUpdatePopupContent(false);
        })
    }

    async initializeBatchGrid(inputValue, data) {
        let component = this;
        this.productGrid = new Grid({
            el: document.getElementById('productGrid'), // Container element
            data: data,
            //rowHeaders: ['checkbox'],
            rowHeaders: [
                {
                    type: 'checkbox',
                    header: '',
                    renderer: {
                        type: CheckboxRenderer
                    }
                }
            ],
            bodyHeight: component.gridBodyHeight,
            //rowHeight: 'auto',
            treeColumnOptions: {
                name: 'ProductName',
                useIcon: false,
                useCascadingCheckbox: false
            },
            header: {
                align: 'left',
                columns: [
                    {
                        name: 'Id',
                        align: 'center'
                    },
                    {
                        name: 'THC',
                        align: 'center'
                    },
                    {
                        name: 'CBD',
                        align: 'center'
                    }
                ]
            },
            columnOptions: {
                resizable: true
            },
            columns: [
                {
                    header: 'Handelsname',
                    name: 'ProductName',
                    align: "left",
                    filter: 'text',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                    }
                },
                {
                    header: 'Produzent',
                    name: 'ProducerName',
                    align: "left",
                    filter: 'text',
                    width: 180,
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                    }
                },
                {
                    header: 'Produkt Kategorie',
                    name: 'ProductType',
                    align: "left",
                    filter: 'text',
                    width: 120,
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                    }
                },
                {
                    header: 'Cultivar',
                    name: 'Strain',
                    align: "left",
                    filter: 'text',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                    }
                },
                {
                    header: 'Dominanz',
                    name: 'StrainFamily',
                    align: "left",
                    filter: 'text',
                    width: 120,
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value}">${props.value}</span>` : "";
                    }
                },
                {
                    header: 'Id',
                    name: 'Id',
                    minWidth: 75,
                    width: 75,
                    align: "center",
                    filter: "number",
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<a target="_blank" href="/page/${props.value}" title="${props.value}">${props.value}</a>` : "";
                    }
                },
                {
                    header: 'THC',
                    name: 'THC',
                    minWidth: 75,
                    width: 75,
                    align: "center",
                    filter: 'number',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value} ${props.row.THC_UNIT}">${props.value} ${props.row.THC_UNIT}</span>` : "";
                    }
                },
                {
                    header: 'CBD',
                    name: 'CBD',
                    minWidth: 75,
                    width: 75,
                    align: "center",
                    filter: 'number',
                    //whiteSpace: 'normal',
                    formatter: function (props) {
                        return props.value ? `<span title="${props.value} ${props.row.CBD_UNIT}">${props.value} ${props.row.CBD_UNIT}</span>` : "";
                    }
                }
            ]
        });

        var allData = this.productGrid.getData();

        if (!this.selectedRowKey.length && inputValue) {
            for (var i = 0; i < allData.length; i++) {
                let data = allData[i];
                let ProducerName = data.ProducerName;
                let ProductName = data.ProductName;
                let DisplayName = `${ProducerName}, ${ProductName}`;
                if (DisplayName == inputValue) {
                    var rowKey = allData[i].rowKey.toString();
                    this.selectedRowKey = rowKey;
                    this.productGrid.check(rowKey);
                    this.productGrid.focus(rowKey, "ProductName", true);
                    break;
                }
            }
        }

        this.productGrid.on("uncheck", (data: any) => {
            if (this.selectedRowKey === data.rowKey.toString()) {
                this.selectedRowKey = "";
            }
        });

        this.productGrid.on("check", (data: any) => {
            this.selectedRowKey = data.rowKey.toString();
            for (var i = 0; i < allData.length; i++) {
                var rowKey = allData[i].rowKey.toString();
                if (rowKey != this.selectedRowKey) {
                    this.productGrid.uncheck(rowKey.toString());
                }
            }
        })

        Grid.applyTheme('default');

        await delay(10);
        this.filterBatchGrid();
    }

    thcTimer: any;
    thcDiagram() {
        clearTimeout(this.thcTimer);
        this.thcTimer = setTimeout(() => {
            d3.select("#thcDiagram").selectAll("svg").remove();
            this.drawTHCDiagram();
        })
    }

    drawTHCDiagram() {
        let data = {};
        const filteredData = this.getFilteredData;
        for (var i = 0; i < filteredData.length; i++) {
            const batch = filteredData[i];
            const THC = Math.ceil(batch.THC);
            if (data[THC]) {
                data[THC] = data[THC] + 1;
            } else {
                data[THC] = 1;
            }
        }

        this.drawBarChart("thcDiagram", data);

    }

    cbdTimer: any;
    cbdDiagram() {
        clearTimeout(this.cbdTimer);
        this.cbdTimer = setTimeout(() => {
            d3.select("#cbdDiagram").selectAll("svg").remove();
            this.drawCBDDiagram();
        })
    }

    drawCBDDiagram() {
        let data = {};
        const filteredData = this.getFilteredData;
        for (var i = 0; i < filteredData.length; i++) {
            const batch = filteredData[i];
            const CBD = Math.ceil(batch.CBD);
            if (data[CBD]) {
                data[CBD] = data[CBD] + 1;
            } else {
                data[CBD] = 1;
            }
        }

        this.drawBarChart("cbdDiagram", data);
    }

    drawBarChart(elmId, data) {
        let component = this;
        let minX = 0;
        let maxX = 0;
        let minY = 0;
        let maxY = 0;

        let KeyArr = [];
        let ValueArr = [];

        let barData = [];
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                KeyArr.push(key);
                ValueArr.push(data[key]);

                barData.push({
                    key: key,
                    value: data[key]
                })
            }
        }
        KeyArr.sort(sortFloat);
        ValueArr.sort(sortFloat);

        if (KeyArr.length) {
            minX = KeyArr[0];
            maxX = KeyArr[KeyArr.length - 1];
        }
        if (ValueArr.length) {
            minY = ValueArr[0];
            maxY = ValueArr[ValueArr.length - 1];
        }


        let ticks = 8;
        if (maxY <= 15) {
            ticks = 5;
        } else if (maxY <= 30) {
            ticks = 6;
        } else if (maxY <= 35) {
            ticks = 7;
        }

        const elmWidth = document.getElementById(elmId).clientWidth;
        let width = elmWidth - 0;
        width = width > 1300 ? 1300 : width;
        width = width < 280 ? 280 : width;
        let height = 120;//width / 1.77;

        let margin = { top: 10, right: 10, bottom: 40, left: 40 };
        width = width - margin.left - margin.right;
        height = height - margin.top - margin.bottom;

        const barChart = d3.select(`#${elmId}`)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");


        barChart.selectAll("g").remove();

        // Add X axis
        const x = d3.scaleBand()
            .domain(barData.map(a => a.key))
            .range([0, width]);

        // Add Y axis
        const y = d3.scaleLinear()
            .domain([0, maxY]).nice()
            .range([height, 0]);

        // add the X gridlines
        barChart.append("g")
            .attr("class", "grid")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x).tickSize(-height));

        // add the Y gridlines
        barChart.append("g")
            .attr("class", "grid")
            .call(d3.axisLeft(y).tickSize(-width));



        // add the X ticks
        barChart.append("g")
            .attr("class", "ticks")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x));

        // add the Y ticks
        barChart.append("g")
            .attr("class", "ticks")
            .call(d3.axisLeft(y).tickFormat((d: any) => { return Math.round(d) === d ? d : ""; }).ticks(ticks));


        // now add titles to the axes
        barChart.append('g')
            .attr("class", "axis-text")
            .append("text")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate(" + -25 + "," + (height / 2) + ")rotate(-90)")  // text is drawn off the screen top left, move down and out and rotate
            .text("Produkte");

        barChart.append('g')
            .attr("class", "axis-text")
            .append("text")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate(" + (width / 2) + "," + (height + 35) + ")")  // centre below axis
            .text("Prozentsatz");

        barChart.append("g")
            .selectAll("bar")
            .data(barData)
            .enter()
            .append("rect")
            .style("fill", "steelblue")
            .attr("x", function (d: any) { return x(d.key); })
            .attr("width", x.bandwidth())
            .attr("y", function (d: any) { return y(d.value); })
            .attr("height", function (d: any) { return height - y(d.value); });
    }


    diagramTimer: any;
    initializeDiagram() {
        this.productSvg = undefined;
        this.productTooltip = undefined;
        d3.select("#productDiagram").selectAll("svg").remove();
        d3.select("body").select(".scatter-tooltip").remove();
        clearTimeout(this.diagramTimer);
        this.diagramTimer = setTimeout(() => {
            this.drawDiagram(true);
        })
    }

    forceSimulation() {
        clearTimeout(this.diagramTimer);
        this.diagramTimer = setTimeout(() => {
            this.drawDiagram(false);
        })
    }

    get diagramData() {
        let productSvgData: any = [];
        let sativaData: any = [];
        let indicaData: any = [];
        let hybridData: any = [];
        let unknownData: any = [];

        let THCArr = [];
        let CBDArr = [];

        const filteredData = this.getFilteredData;
        for (var i = 0; i < filteredData.length; i++) {
            const batch = filteredData[i];
            let StrainFamily = batch.StrainFamily || "Nicht bekannt";
            let similarBatches = batch._children;
            if (similarBatches) {
                for (var j = 0; j < similarBatches.length; j++) {
                    let _batch = similarBatches[j];
                    if (_batch.StrainFamily != StrainFamily) {
                        StrainFamily = "Nicht bekannt";
                        break;
                    }
                }
            }


            const THC = parseFloat(batch.THC);
            const CBD = parseFloat(batch.CBD);
            THCArr.push(THC);
            CBDArr.push(CBD);

            const obj = {
                Id: batch.Id,
                ProductName: batch.ProductName,
                ProducerName: batch.ProducerName,
                StrainFamily: StrainFamily,
                THC: THC,
                CBD: CBD
            };

            if (StrainFamily === 'Sativa') {
                sativaData.push(obj);
            }
            else if (StrainFamily === 'Indica') {
                indicaData.push(obj);
            }
            else if (StrainFamily === 'Hybrid') {
                hybridData.push(obj);
            }
            else {
                unknownData.push(obj);
            }
        }

        productSvgData.push(
            {
                StrainFamily: "Sativa",
                Data: sativaData
            },
            {
                StrainFamily: "Indica",
                Data: indicaData
            },
            {
                StrainFamily: "Hybrid",
                Data: hybridData
            },
            {
                StrainFamily: "Nicht bekannt",
                Data: unknownData
            }
        )

        THCArr.sort(sortFloat);
        CBDArr.sort(sortFloat);


        let minTHC = 0;
        let maxTHC = 0;
        let minCBD = 0;
        let maxCBD = 0;

        if (THCArr.length) {
            minTHC = THCArr[0];
            maxTHC = THCArr[THCArr.length - 1];
        }
        if (CBDArr.length) {
            minCBD = CBDArr[0];
            maxCBD = CBDArr[CBDArr.length - 1];
        }

        minTHC -= 1;
        minCBD -= 1;
        maxTHC += 1;
        maxCBD += 1;

        return {
            productSvgData: productSvgData,
            minTHC: minTHC,
            maxTHC: maxTHC,
            minCBD: minCBD,
            maxCBD: maxCBD
        };
    }

    get recommendedData() {
        let recommended;
        if (this.productOneOption) {
            recommended = QuestOneCenterRadius.find(a => a.Option === this.productOneOption.Label);
        }
        return recommended;
    }

    drawDiagram(createSvg) {
        let component = this;
        let productSvgData = this.diagramData.productSvgData;
        let minTHC = this.diagramData.minTHC;
        let maxTHC = this.diagramData.maxTHC;
        let minCBD = this.diagramData.minCBD;
        let maxCBD = this.diagramData.maxCBD;

        let recommended = this.recommendedData;

        let width = this.jsPanelContentWidth - 30;
        width = width > 1300 ? 1300 : width;
        width = width < 700 ? 700 : width;
        let height = width / 1.77;

        let margin = { top: 50, right: 120, bottom: 50, left: 50 };
        width = width - margin.left - margin.right;
        height = height - margin.top - margin.bottom;

        if (!this.productSvg) {
            this.productSvg = d3.select("#productDiagram")
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        }
        if (!this.productTooltip) {
            this.productTooltip = d3.select("body").append("div")
                .attr("class", "scatter-tooltip");
        }

        const productSvg = this.productSvg;
        const tooltip = this.productTooltip;

        productSvg.selectAll("g").remove();

        // Add X axis
        const x = d3.scaleLinear()
            .domain([minCBD, maxCBD])
            .range([0, width]);

        // Add Y axis
        const y = d3.scaleLinear()
            .domain([minTHC, maxTHC])
            .range([height, 0]);

        // add the X gridlines
        productSvg.append("g")
            .attr("class", "grid")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x).tickSize(-height));

        // add the Y gridlines
        productSvg.append("g")
            .attr("class", "grid")
            .call(d3.axisLeft(y).tickSize(-width));



        // add the X ticks
        productSvg.append("g")
            .attr("class", "ticks")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x));

        // add the Y ticks
        productSvg.append("g")
            .attr("class", "ticks")
            .call(d3.axisLeft(y));


        // now add titles to the axes
        productSvg.append('g').append("text")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate(" + -25 + "," + (height / 2) + ")rotate(-90)")  // text is drawn off the screen top left, move down and out and rotate
            .text("THC");

        productSvg.append('g').append("text")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate(" + (width / 2) + "," + (height + 35) + ")")  // centre below axis
            .text("CBD");

        if (recommended) {
            productSvg.append('g')
                .attr("class", "recommended")
                .append("circle")
                .style("opacity", 0.5)
                .attr("cx", x(recommended.Center.CBD))
                .attr("cy", y(recommended.Center.THC))
                .attr("r", recommended.Radius.THC)
                .style("fill", "#FF7171");

            productSvg.append('g')
                .attr("class", "recommended")
                .append("circle")
                .style("opacity", 0.5)
                .attr("cx", x(recommended.Center.CBD))
                .attr("cy", y(recommended.Center.THC))
                .attr("r", recommended.Radius.CBD)
                .style("fill", "#649DFF");
        }

        let hoverOn: 'DOT' | 'TOOLTIP' | '' = '';
        let hoverTimer: any;
        let radius = 7;

        let fixedData = [];
        for (var i = 0; i < productSvgData.length; i++) {
            const batch = productSvgData[i];
            const data = batch.Data;
            fixedData = [...fixedData, ...data];
        }

        const simulation = d3.forceSimulation(fixedData)
            .force("x", d3.forceX((d: any) => x(d.CBD)))
            .force("y", d3.forceY((d: any) => y(d.THC)))
            .force("collide", d3.forceCollide(radius + this.sliderValue));

        simulation.tick(100);
        simulation.stop();

        function hideTooltip(thisDot, time) {
            d3.select(thisDot).select("circle").style("opacity", 0.5);
            hoverTimer = setTimeout(() => {
                tooltip.classed("tooltip-visible", false);
            }, time);
        }

        function updateTooltipPosition(event) {
            const left = event.pageX < 200 ? (event.pageX + 10) : ((event.pageX - 180 - 15));

            tooltip.style("left", left + "px")
                .style("top", (event.pageY - 55) + "px");

        }

        function fnDrawDots(data) {
            const dot = productSvg.append("g")
                .attr("class", "dots")
                .selectAll("dot")
                .data(data)
                .join("g")
                .attr("transform", (d: any) => `translate(${d.x},${d.y})`)
                .call(g => g.append("circle")
                    .attr("class", "dot")
                    .attr("r", radius)
                    .style("opacity", 0.5)
                    .attr("data-strain-family", (d: any) => { return d.StrainFamily; })
                    .style("fill", (d: any) => {
                        const color = d.StrainFamily === 'Sativa' ? "red" : d.StrainFamily === 'Indica' ? "green" : d.StrainFamily === 'Hybrid' ? "blue" : "black";
                        return color;
                    })
                );

            dot.on("mouseover", function (event, d: any) {
                clearTimeout(hoverTimer);
                const thisDot = this;
                const thisBatch = d;
                hoverOn = 'DOT';
                d3.selectAll("dot").select("circle").style("opacity", 0.5);
                d3.select(this).select("circle").style("opacity", 0.75);

                tooltip.classed("tooltip-visible", true);

                const html = `
        <div class="tooltip-title">${d.ProductName}</div>
        <div class="tooltip-title">${d.ProducerName}</div>
        <div><label>THC</label>&nbsp;&nbsp;${d.THC}</div>
        <div><label>CBD</label>&nbsp;&nbsp;${d.CBD}</div>
        <div class="tooltip-button">
        <button type="button" class="btn btn-sm btn-info">Select</button>
        </div>
        `;
                tooltip.html(html);

                updateTooltipPosition(event);

                tooltip.on("mouseover", function () {
                    hoverOn = 'TOOLTIP';
                    clearTimeout(hoverTimer);
                });

                tooltip.on("mouseout", function () {
                    hoverOn = '';
                    clearTimeout(hoverTimer);
                    hideTooltip(thisDot, 300);
                });

                tooltip.select("button").on("click", function (d) {
                    hideTooltip(thisDot, 0);
                    component.onSelectBatch.emit(thisBatch);
                })
            });

            dot.on("mousemove", function (event, d: any) {
                if (hoverOn !== 'DOT') {
                    return;
                }
                clearTimeout(hoverTimer);
                updateTooltipPosition(event);
            });

            dot.on("mouseout", function (d) {
                if (hoverOn === 'TOOLTIP') {
                    return;
                }
                clearTimeout(hoverTimer);
                hideTooltip(this, 300);
            });

            dot.on("dblclick", function (event, d: any) {
                hideTooltip(this, 0);
                component.onSelectBatch.emit(d);
            });
        }

        fnDrawDots(fixedData);

        // Add dots
        for (var i = 0; i < productSvgData.length; i++) {
            const batch = productSvgData[i];
            const color = batch.StrainFamily === 'Sativa' ? "red" : batch.StrainFamily === 'Indica' ? "green" : batch.StrainFamily === 'Hybrid' ? "blue" : "black";

            // draw legend
            var legend = productSvg.append("g")
                .attr("class", "legend");

            legend.append("circle")
                .style("opacity", 0.5)
                .attr("cx", width + 15)
                .attr("cy", (15 * (i + 1)) * 1.5)
                .attr("r", radius + 1)
                .style("fill", color);

            // draw legend text
            legend.append("text")
                .attr("x", width + 28)
                .attr("y", (15 * (i + 1)) * 1.5)
                .attr("dy", "0.35em")
                .style("text-anchor", "start")
                .text(batch.StrainFamily);

            legend.on("mouseover", function (d) {
                d3.select(this).select("circle").style("opacity", 0.75);
                d3.selectAll(`[data-strain-family="${batch.StrainFamily}"]`).style("opacity", 0.75);
            });
            legend.on("mouseout", function (d) {
                d3.select(this).select("circle").style("opacity", 0.5)
                d3.selectAll(`[data-strain-family="${batch.StrainFamily}"]`).style("opacity", 0.5);
            });
        }

    }
}

class CheckboxRenderer {
    el: any = "";
    show: boolean;
    constructor(props) {
        const { grid, rowKey } = props;
        const data = grid.getData();
        this.show = false;
        if (data.find(d => d.rowKey === rowKey && d.Level === 1)) {
            this.show = true;
        }

        const div = document.createElement('div');
        div.className = 'tui-grid-row-header-checkbox';

        if (this.show) {
            const input = document.createElement('input');

            div.appendChild(input);

            input.type = 'checkbox';
            input.addEventListener('change', () => {
                if (input.checked) {
                    grid.check(rowKey);
                } else {
                    grid.uncheck(rowKey);
                }
            });
        }

        this.el = div;

        this.render(props);
    }

    getElement() {
        return this.el;
    }

    render(props) {
        if (this.show) {
            const input = this.el.querySelector('input');
            const checked = Boolean(props.value);

            input.checked = checked;
        }
    }
}
